import {Component} from '@angular/core';

@Component({
    selector: 'bs-complete-icon',
    template: require('./complete.icon.html')
})
export class CompleteIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/complete.icon.ts